import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.j1{width:1px;}.ssr-plugin'
import '.dx{height:1rem;}.ssr-plugin'
import '.jp{background-color:var(--palette-blue-200);}.ssr-plugin'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import useMediaQuery from '@app/util/useMediaQuery'
import {
  faLocationDot,
  faLightbulb,
  faHandHoldingCircleDollar,
  IconDefinition,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { i18n } from '@i18n/index'
import { pluralize } from '@i18n/localizeHelper'
import { useLanguage } from '@i18n/useLanguage'
import { styled } from 'inlines'

export type RegionStatusRowProps = {
  subsidies?: number
  plots?: number
  initiatives: number
  isLocked?: boolean
  version?: 'light' | 'dark'
}

export const RegionStatusRow = ({
  subsidies,
  plots,
  isLocked = false,
  initiatives,
  version = 'dark',
}: RegionStatusRowProps) => {
  const isMobile = useMediaQuery()
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app.regionCard
  const color =
    version === 'dark' ? 'var(--palette-blue-500)' : 'var(--palette-white)'

  return (
    <div className="d r s"
      style={{
        flexDirection: isMobile ? 'column' : 'row',}}
    >
      {!!subsidies && (
        <Section
          text={pluralize(translations.subsidies, subsidies)}
          color={color}
          icon={faHandHoldingCircleDollar}
        />
      )}

      {!subsidies && !!plots && (
        <Section
          text={pluralize(translations.plots, plots)}
          color={color}
          icon={faLocationDot}
          isLocked={isLocked}
        />
      )}

      {/* Separator */}
      {(!!subsidies || !!plots) && !isMobile && (
        <div className="j1 dx jp"
        />
      )}

      <Section
        text={pluralize(translations.initiatives, initiatives)}
        color={color}
        icon={faLightbulb}
        isLocked={isLocked}
      />
    </div>
  )
}

const Section = ({
  text,
  color,
  icon,
  isLocked,
}: {
  text: string
  color: string
  icon: IconDefinition
  isLocked?: boolean
}) => {
  return (
    <Row
      style={{
        alignItems: 'center',
        gap: '0.25rem',
      }}
    >
      <FontAwesomeIcon
        icon={icon}
        style={{
          color: color,
          height: '0.75rem',
          width: '0.75rem',
        }}
      />
      <Text.Small
        color={color}
        style={{
          filter: isLocked ? 'blur(3px)' : 'none',
        }}
      >
        {text}
      </Text.Small>
    </Row>
  )
}
